export async function ocrUpload(formData) {
  const res = await fetch("/api/ocr", { method: "POST", body: formData });
  if (!res.ok) throw new Error("OCR upload failed");
  return res.json();
}
